<template>
  <q-dialog v-model="isVisible">
    <q-card style="width: 400px; max-width: 80vw">
      <q-form
        autocorrect="off"
        autocapitalize="off"
        autocomplete="off"
        spellcheck="false"
        @submit="onSubmit"
      >
        <q-card-section class="row items-center justify-between">
          <span class="text-h5">
            {{
              type === 'topUp'
                ? $t('components.topUpModal.topUpTitle')
                : $t('components.topUpModal.topDownTitle')
            }}
          </span>

          <q-btn
            :disable="isLoading"
            icon="close"
            flat
            round
            dense
            v-close-popup
          />
        </q-card-section>

        <q-card-section v-if="error" class="q-pt-none">
          <q-banner class="text-white bg-red" rounded>
            {{ error.message }}
          </q-banner>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <div class="row q-col-gutter-md">
            <div class="col-12">
              <q-input
                v-model.number="amount"
                :label="$t('components.topUpModal.labels.amount')"
                :error="v$.amount.$error"
                :error-message="$t('components.topUpModal.errors.amount')"
                type="number"
                step="1"
                min="0"
                hide-bottom-space
                autofocus
              />
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn :disable="isLoading" color="primary" flat @click="close">
            {{ $t('components.topUpModal.cancelButtonTitle') }}
          </q-btn>

          <q-btn
            :loading="isLoading"
            :label="
              type === 'topUp'
                ? $t('components.topUpModal.topUpButtonTitle')
                : $t('components.topUpModal.topDownButtonTitle')
            "
            type="submit"
            color="primary"
            flat
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import useValidate from '@vuelidate/core';
import { required, minValue, maxValue } from '@vuelidate/validators';

import { sendCredits } from '@/api/credits';

export default {
  props: {
    doctorId: {
      type: Number,
      required: true,
    },
    doctorBalance: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      v$: useValidate(),
      isVisible: false,
      isLoading: false,
      error: null,
      amount: null,
      type: null,
    };
  },
  validations() {
    const validationRules = {
      amount: {
        required,
        minValue: minValue(1),
      },
    };

    if (this.type === 'topDown') {
      validationRules.amount.maxValue = maxValue(this.doctorBalance);
    }

    return validationRules;
  },
  methods: {
    open(type) {
      this.type = type;
      this.error = null;
      this.amount = null;

      this.v$.$reset();

      this.isLoading = false;
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
    async onSubmit() {
      this.error = null;

      this.v$.$touch();

      if (!this.v$.$invalid) {
        try {
          this.isLoading = true;

          const transaction = await sendCredits({
            doctorId: this.doctorId,
            amount:
              this.type === 'topUp'
                ? Math.abs(this.amount)
                : -Math.abs(this.amount),
          });

          this.$emit('topup', transaction);

          this.$q.notify({
            icon: 'paid',
            type: 'positive',
            position: 'center',
            message: this.$t('components.topUpModal.successfulTopUpMessage', {
              title: transaction.destination.fullName,
              credits: this.$numeral(transaction.credits).format('0,0'),
            }),
          });

          this.close();
        } catch (error) {
          this.error = error;
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
